"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProviderWithFallback = void 0;
const ethers_1 = require("ethers");
function getProviderWithFallback(...rpcNodeUrls) {
    return new ethers_1.ethers.providers.FallbackProvider(rpcNodeUrls.filter((url) => url).map((url) => new ethers_1.ethers.providers.JsonRpcProvider(url)));
}
exports.getProviderWithFallback = getProviderWithFallback;
//# sourceMappingURL=FallbackProvider.js.map